module.exports = __webpack_public_path__ + "static/img/clothing_02.940118a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_02.png
// module id = y+zV
// module chunks = 0